import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VerifyPhoneNumberService {
  constructor(private http: HttpClient) {}

  sendCode(msisdn) {
    return this.http.post('/msisdns/verification/start', {
      msisdn,
      verifyType: 'SMS'
    });
  }
  verifyCode(msisdn, verificationCode) {
    return this.http.post('/msisdns/verify', {
      msisdn,
      verificationCode
    });
  }
}
